import { ReversePipe } from './pipe/reverse.pipe';
import { KetranslatePipe } from './pipe/ketranslate.pipe';
import {
  MatTreeModule,
  MatTreeFlattener,
  MatTreeFlatDataSource,
} from '@angular/material/tree';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatSliderModule } from '@angular/material/slider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import {
  MatBottomSheetModule,
  MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
} from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import {
  MatNativeDateModule,
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS,
} from '@angular/material/core/';
import { CenterMatmenuDirective } from './directive/center-matmenu.directive';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DialogOpenapp } from './dialog-openapp/dialog-openapp';
import {
  FontAwesomeModule,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
// import { far } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
// import {
  // faBars,
  // faUserCircle,
  // faPowerOff,
  // faCog,
  // faPlayCircle,
  // faRocket,
  // faPlus,
  // faEdit,
  // faTrash,
  // faTimes,
  // faCaretUp,
  // faCaretDown,
  // faExclamationTriangle,
  // faFilter,
  // faTasks,
  // faCheck,
  // faSquare,
  // faLanguage,
  // faPaintBrush,
  // faLightbulb,
  // faWindowMaximize,
  // faStream,
  // faBook,
  // faMapMarkerAlt,
  // faExchangeAlt,
  // faPlusCircle,
  // faTrashAlt,
  // faMinus,
  // faFlag,
  // faChild,
  // faMale,
  // faAngleDoubleDown,
  // faPencilAlt,
  // faAngleDoubleUp,
  // faThList,
  // faList,
  // faObjectGroup,
  // faPlane,
  // faStop,
  // faEnvelope,
  // faPhoneSquare,
  // faExclamationCircle,
  // faClock,
  // faSearch,
  // faSignOutAlt,
  // faSuitcaseRolling,
  // faChair,
  // fas,
  // faThumbtack,
// } from '@fortawesome/free-solid-svg-icons';
// import { from } from 'rxjs';
import { SplitByKeyPipe } from './pipe/splitbykey.pipe';
import { BlockcutcopypasteDirective } from './directive/blockcutcopypaste.directive';
import { PreventKeysDirective } from './directive/prevent-keys.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SafePipe } from './pipe/safe.pipe';
import { ColNamePipe } from './pipe/colname.pipe';
import { PopoverComponent } from './popover/popover.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgxContentLoadingModule } from 'ngx-content-loading';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DialogCommentComponent } from './dialog-comment/dialog-comment.component';
export const MOMENT_DATE_FORMATS = {
  parse: {
    dateInput: 'D/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM Y',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM Y',
  },
};

@NgModule({
  declarations: [
    SplitByKeyPipe,
    PopoverComponent,
    BlockcutcopypasteDirective,
    PreventKeysDirective,
    CenterMatmenuDirective,
    SafePipe,
    ColNamePipe,
    KetranslatePipe,
    ReversePipe,
    DialogCommentComponent,
    DialogOpenapp,
  ],
  entryComponents: [PopoverComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ScrollingModule,
    MatButtonModule,
    DragDropModule,
    MatSortModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatSelectModule,
    NgxContentLoadingModule,
    MatTabsModule,
    MatExpansionModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    ClipboardModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatTreeModule,
    MatCheckboxModule,
    MatListModule,
    MatMenuModule,
    MatRadioModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatSliderModule,
    MatBadgeModule,
    MatDialogModule,
    MatBottomSheetModule,
    MatProgressBarModule,
    MatTableModule,
    FontAwesomeModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    NgxContentLoadingModule,
    ReactiveFormsModule,
    TranslateModule,
    ScrollingModule,
    MatButtonModule,
    MatRadioModule,
    MatSortModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatSelectModule,
    ClipboardModule,
    MatTabsModule,
    MatExpansionModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatCardModule,
    MatDatepickerModule,
    MatTreeModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatCheckboxModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatSliderModule,
    MatBadgeModule,
    SplitByKeyPipe,
    SafePipe,
    ColNamePipe,
    KetranslatePipe,
    ReversePipe,
    MatBottomSheetModule,
    MatProgressBarModule,
    MatTableModule,
    FontAwesomeModule,
    BlockcutcopypasteDirective,
    PreventKeysDirective,
    CenterMatmenuDirective,
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
  ],
})
export class SharedModule {
  constructor(library: FaIconLibrary) {

    // library.addIconPacks(fas, far);

    library.addIcons(
      // faBars,
      // faUserCircle,
      // faPowerOff,
      // faCog,
      // faRocket,
      // faPlayCircle,
      // faPlus,
      // faMale,
      // faEdit,
      // faTrash,
      // faTimes,
      // // faChair,
      // faCaretUp,
      // faCaretDown,
      // faExclamationTriangle,
      // faFilter,
      // // faSuitcaseRolling,
      // faTasks,
      // faCheck,
      // faSquare,
      // faLanguage,
      // // faEnvelope,
      // faPaintBrush,
      // faLightbulb,
      // // faExclamationCircle,
      // // faSearch,
      // // faSignOutAlt,
      // // faPhoneSquare,
      // faWindowMaximize,
      // // faClock,
      // faStream,
      // faBook,
      // faMapMarkerAlt,
      // faAngleDoubleDown,
      // faAngleDoubleUp,
      // faExchangeAlt,
      // // faPlane,
      // faPlus,
      // faPlusCircle,
      // faTrashAlt,
      // faFlag,
      // faCheck,
      // // faThumbtack,
      // faMinus,
      // faChild,
      // faThList,
      // faPencilAlt,
      // // faStop,
      // faList,
      // faObjectGroup,
      // faMale
    );
  }
}
